import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/layout/SiteLayout";

import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import Iletisim from "@/pages/Iletisim";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Kvkk from "@/pages/Kvkk";
import Fiyatlar from "@/pages/Fiyatlar";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";

const SERVICE_SLUGS = [
    "pico-lazer-dovme-silme",
    "istanbul-dovme-silme",
    "esenyurt-dovme-silme",
    "fraksiyonel-co2-lazer",
    "faca-izi-tedavisi",
    "yanik-izi-tedavisi",
    "akne-izi-tedavisi",
    "ameliyat-izi-tedavisi",
    "cover-up-oncesi-dovme-actirma",
];

function withLayout(node) {
    return <SiteLayout>{node}</SiteLayout>;
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster
                    position="top-right"
                    theme="dark"
                    toastOptions={{
                        style: {
                            background: "#0E0E0E",
                            border: "1px solid rgba(255,255,255,0.08)",
                            color: "#fff",
                        },
                    }}
                />
                <Routes>
                    <Route path="/" element={withLayout(<Home />)} />
                    <Route path="/iletisim" element={withLayout(<Iletisim />)} />
                    <Route path="/blog" element={withLayout(<Blog />)} />
                    <Route path="/blog/:slug" element={withLayout(<BlogPost />)} />
                    <Route path="/kvkk-aydinlatma-metni" element={withLayout(<Kvkk />)} />
                    <Route path="/dovme-silme-fiyatlari" element={withLayout(<Fiyatlar />)} />

                    {SERVICE_SLUGS.map((slug) => (
                        <Route
                            key={slug}
                            path={`/${slug}`}
                            element={withLayout(<ServiceDetail slug={slug} />)}
                        />
                    ))}

                    {/* Admin */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<Navigate to="/admin/leads" replace />} />
                        <Route path="leads" element={<AdminLeads />} />
                        <Route path="blog" element={<AdminBlog />} />
                        <Route path="blog/new" element={<AdminBlogEditor />} />
                        <Route path="blog/:id/edit" element={<AdminBlogEditor />} />
                    </Route>

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
